<template>
	<div class="frequently_asked_question">
		<h4 class="question">
			{{faq.question}}
		</h4>
		<div
				class="answer"
				v-html="faq.answer"
		>
		</div>
	</div>
	
</template>

<script>
	export default {
		name: "FrequentlyAskedQuestionBox",
		props: {
			faq: {
				type: Object,
				required: true,
			}
		},
	}
</script>

<style lang="scss">
	@import '../styles/variables';

	.frequently_asked_question {
		transition: background-color 400ms ease-in-out;
		margin: 0 1rem 1rem;
		padding: 1.5rem 1rem;

		&:hover{
			background-color: rgba(125,125,125,.5);
		}

		h4.question{
			color: $pallete_main_color;
			margin-top: 0;
		}

		.answer {
			text-align: justify;
			text-justify: inter-word;
			text-indent: 12px;
			margin: 0 5%;

			a {
				color: #7986cb;
			}

			p:last-of-type {
				margin: 0;
			}
		}
	}
</style>